/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeFirIcon16Light = forwardRef('NaturePlantTreeFirIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.252 1.346a1 1 0 0 0-1.501 0L1.918 6.838A.7.7 0 0 0 2.444 8H4.24L.839 11.924A.65.65 0 0 0 1.33 13h5.672v2.5a.5.5 0 0 0 1 0V13h5.671a.65.65 0 0 0 .491-1.076L10.764 8h1.795a.7.7 0 0 0 .526-1.162L8.252 1.346ZM5.335 7H3.108l4.394-4.993L11.896 7H9.668c-.42 0-.653.51-.378.827L12.907 12H2.097l3.616-4.173A.504.504 0 0 0 5.335 7Z" })));
});
